import React from 'react';
import { Phone } from 'lucide-react';

export const CallButton = () => {
  const handleCall = () => {
    window.location.href = 'tel:+971566671468';
  };

  return (
    <button
      onClick={handleCall}
      className="fixed right-4 md:right-6 bottom-24 md:bottom-28 z-50 bg-red-600 hover:bg-red-700 text-white rounded-full p-3 md:p-4 shadow-2xl hover:scale-110 transition-all duration-300 flex items-center space-x-2 group"
      aria-label="Call Now"
      title="Call +971 56 667 1468"
    >
      <Phone className="w-5 h-5 md:w-6 md:h-6" />
      <span className="hidden group-hover:inline-block font-semibold whitespace-nowrap">
        Call Now
      </span>
    </button>
  );
};
